import { Map } from 'immutable';
import { TEMPORARY_ITEM_ID } from '@instructure/quiz-common';
import Item from '../records/Item';
export function getItemById(state, id) {
  if (id === TEMPORARY_ITEM_ID) {
    return getTemporaryItem(state);
  }
  return Item.create(state.getIn(['items', id]));
}
export function getTemporaryItem(state) {
  var temporaryItemData = state.getIn(['modifications', 'items', TEMPORARY_ITEM_ID], Map());
  return Item.create(temporaryItemData);
}